/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyClientFlat
 */
export interface ReadOnlyClientFlat {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientFlat
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    address?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    fieldOfActivity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    billingCode?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    correspondenceAddress?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    contact?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    emailForInvocing?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    identificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    vatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    taxNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    bankingConnection?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    timeZone?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientFlat
     */
    deleted: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    languageIso6391?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClientFlat
     */
    isPartner?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    styles?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    logo?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    metadata?: object;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClientFlat
     */
    costPerKm?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    fleetType?: ReadOnlyClientFlatFleetTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClientFlat
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyClientFlat
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClientFlat
     */
    mamId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClientFlat
     */
    ewOffice?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientFlat
     */
    country?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientFlat
     */
    externalSystem?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClientFlat
     */
    referrer?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyClientFlat
     */
    readonly modules?: Array<number>;
}

export function ReadOnlyClientFlatFromJSON(json: any): ReadOnlyClientFlat {
    return ReadOnlyClientFlatFromJSONTyped(json, false);
}

export function ReadOnlyClientFlatFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyClientFlat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'externalId': json['external_id'],
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'fieldOfActivity': !exists(json, 'field_of_activity') ? undefined : json['field_of_activity'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'billingCode': !exists(json, 'billing_code') ? undefined : json['billing_code'],
        'correspondenceAddress': !exists(json, 'correspondence_address') ? undefined : json['correspondence_address'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'emailForInvocing': !exists(json, 'email_for_invocing') ? undefined : json['email_for_invocing'],
        'identificationNumber': !exists(json, 'identification_number') ? undefined : json['identification_number'],
        'vatNumber': !exists(json, 'vat_number') ? undefined : json['vat_number'],
        'taxNumber': !exists(json, 'tax_number') ? undefined : json['tax_number'],
        'bankingConnection': !exists(json, 'banking_connection') ? undefined : json['banking_connection'],
        'timeZone': !exists(json, 'time_zone') ? undefined : json['time_zone'],
        'deleted': json['deleted'],
        'languageIso6391': !exists(json, 'language_iso_639_1') ? undefined : json['language_iso_639_1'],
        'isPartner': !exists(json, 'is_partner') ? undefined : json['is_partner'],
        'styles': !exists(json, 'styles') ? undefined : json['styles'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'fleetType': !exists(json, 'fleet_type') ? undefined : json['fleet_type'],
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'mamId': !exists(json, 'mam_id') ? undefined : json['mam_id'],
        'ewOffice': !exists(json, 'ew_office') ? undefined : json['ew_office'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'referrer': !exists(json, 'referrer') ? undefined : json['referrer'],
        'modules': !exists(json, 'modules') ? undefined : json['modules'],
    };
}

export function ReadOnlyClientFlatToJSON(value?: ReadOnlyClientFlat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_id': value.externalId,
        'name': value.name,
        'address': value.address,
        'field_of_activity': value.fieldOfActivity,
        'language': value.language,
        'currency': value.currency,
        'billing_code': value.billingCode,
        'correspondence_address': value.correspondenceAddress,
        'contact': value.contact,
        'email_for_invocing': value.emailForInvocing,
        'identification_number': value.identificationNumber,
        'vat_number': value.vatNumber,
        'tax_number': value.taxNumber,
        'banking_connection': value.bankingConnection,
        'time_zone': value.timeZone,
        'deleted': value.deleted,
        'language_iso_639_1': value.languageIso6391,
        'is_partner': value.isPartner,
        'styles': value.styles,
        'logo': value.logo,
        'metadata': value.metadata,
        'cost_per_km': value.costPerKm,
        'fleet_type': value.fleetType,
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'mam_id': value.mamId,
        'ew_office': value.ewOffice,
        'country': value.country,
        'external_system': value.externalSystem,
        'referrer': value.referrer,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyClientFlatFleetTypeEnum {
    Trucks = 'trucks',
    LightVehicles = 'light_vehicles',
    Mixed = 'mixed'
}


